// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__YFBWF","underRow":"Footer_underRow__H4EDK","footerColumn":"Footer_footerColumn__ws1nY"};